export default "__VITE_ASSET__JKKwWbsl__"